import { createTheme } from "@mui/material";

// A custom theme for this app
const bodytechTheme = createTheme({
  overrides: {
    MuiPaper: {
      rounded: {
        border: "none",
        boxShadow: "0px 0px 1px rgba(52,58,67,0.75)",
      },
    },
    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: "transparent",
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 13,
      },
    },
    MuiButton: {
      label: {
        fontFamily: "Gotham medium",
        textTransform: "uppercase",
      },
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: "8px",
      },
      root: {
        width: "100%",
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        padding: "9px 0 0 0 !important",
      },
      endAdornment: {
        top: "calc(50% - 9px)",
      },
    },
    MuiOutlinedInput: {
      root: {
        // boxShadow: '0px 0px 2px rgba(52,58,67,0.10),0px 1px 2px rgba(52,58,67,0.08),0px 1px 4px rgba(52,58,67,0.08)',
        "label + &": {
          marginTop: "0.5rem",
        },
      },
      adornedStart: {
        paddingLeft: "0px !important",
      },
      input: {
        padding: "14.5px 14px !important",
        borderRadius: 8,
        border: "1px solid #ced4da",
      },
      notchedOutline: {
        display: "none",
      },
      multiline: {
        padding: "0",
        textarea: {
          padding: "11.5px 14px",
        },
      },
    },
    WAMuiChipInput: {
      inputRoot: {
        padding: "0 14px !important",
        boxShadow:
          "0px 0px 2px rgba(52,58,67,0.10), 0px 1px 2px rgba(52,58,67,0.08), 0px 1px 4px rgba(52,58,67,0.08)",
      },
      chip: {
        marginTop: "8px !important",
      },
      input: {
        boxShadow: "none !important",
        marginTop: "0",
      },
    },
    MuiLink: {
      root: {
        fontWeight: "700",
        "&:focus": {
          outlineColor: "#266678",
        },
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '.rccs__card > div, .rccs__card__background': {
          background: 'linear-gradient(45deg, #3D4447, #2F3438)',
          color: '#F7E8B5'
        },
        '.rccs__card:not(.rccs__card--unknown) .rccs__card__background': {
          left: '-1000%',
          transition: 'none'
        },
        '.rccs__chip': {
          top: '25%',
        }
      }
    }
  },
  palette: {
    type: "light",
    action: {
      background: "#E3E3E3",
      disabled: "white",
    },
    primary: {
      light: "#EB6608",
      main: "#EB6608",
      dark: "#EB6608",
      contrastText: "#fff",
    },
    secondary: {
      light: "#5c8c9c",
      main: "#000",
      dark: "#EB6608",
    },
    error: {
      light: "#d49494",
      main: "#cb7c7a",
      dark: "#a26362",
    },
    warning: {
      light: "#FCA993",
      main: "#3C3C3B",
      dark: "#3C3C3B",
      contrastText: "#fff",
    },
    success: {
      light: "#73baa9",
      main: "#48ac98",
      dark: "#3a8a7a",
    },
    text: {
      primary: "#0f2930",
      secondary: "#53627c",
      disabled: "#a6aebc",
      hint: "#a6aebc",
    },
    background: {
      paper: "#ffffff",
      default: "#ffffff",
    },
  },
  shadows: [
    "none",
    "0px 0px 12px rgba(52,58,67,0.10),0px 1px 2px rgba(52,58,67,0.08),0px 1px 4px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 2px 5px rgba(52,58,67,0.08),0px 5px 15px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 5px 10px rgba(52,58,67,0.08),0px 15px 35px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 10px 20px rgba(52,58,67,0.08),0px 20px 40px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
    "0px 0px 2px rgba(52,58,67,0.10),0px 18px 38px rgba(52,58,67,0.08),0px 35px 65px rgba(52,58,67,0.08)",
  ],
  typography: {
    fontFamily: [
      '"Gotham"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h1: {
      fontWeight: "700",
    },
    h2: {
      fontWeight: "700",
    },
    h3: {
      fontWeight: "700",
    },
    h4: {
      fontWeight: "700",
    },
    h5: {
      fontWeight: "700",
      fontFamily: "Gotham medium",
      textTransform: "uppercase",
      fontSize: 15,
    },
    h6: {
      fontWeight: "700",
      fontFamily: "Gotham",
    },
    body1: {
      fontFamily: "Gotham book",
    },
    body2: {
      fontFamily: "Gotham book",
      fontSize: 16,
      wordBreak: "break-word",
    },
    title: {
      fontFamily: "Gotham",
      color: "#282828",
      fontWeight: 100,
      fontSize: 35,
    },
    button: {
      textTransform: "none",
      fontSize: "15px", // 18px
      fontWeight: "100",
      color: "black",
      height: 45,
      width: 224,
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default bodytechTheme;
